module.exports = __webpack_public_path__ + "img/6554689.075c0442.png";